import Brands from './modules/brands';
import Locations from './modules/location';
import Menu from './modules/menu';
import { toggleText } from './utilities';

document.addEventListener( 'DOMContentLoaded', () => {
	new Menu();

	if (
		navigator.userAgent.toLowerCase().indexOf( 'safari/' ) > -1 &&
		navigator.userAgent.toLowerCase().indexOf( 'chrome' ) === -1
	) {
		document.body.classList.add( 'safari' );
	}

	const locationElements = document.querySelector( '.module-career' );
	if ( locationElements ) {
		new Locations( locationElements );
	}

	const brandElements = document.querySelector( '.module-brands' );
	if ( brandElements ) {
		new Brands( brandElements );
	}

	const toggleTextElements = document.querySelector(
		'.wp-block-group.toggle-text'
	);
	if ( toggleTextElements ) {
		toggleText( toggleTextElements.parentNode );
	}

	const missionElements = document.querySelector( '.module-mission' );
	if ( missionElements ) {
		toggleText( missionElements, '' );
	}
} );
